const arrowLeft = document.querySelector(".w-slider-arrow-left");
const arrowRight = document.querySelector(".w-slider-arrow-right");
const sliderMask = document.querySelector(".w-slider-mask");
const slides = document.querySelectorAll(".w-slide");
const slideWidth = slides[0].getBoundingClientRect().width;
const sliderDots = document.querySelectorAll(".w-slider-dot");

let currentSlide = 0;

// Set the first dot to active by default
sliderDots[0].classList.add("w-active");
sliderDots[0].setAttribute("aria-pressed", "true");
sliderDots[0].setAttribute("tabindex", "0");

function updateSlidePosition() {
  sliderMask.style.transition = "transform 0.5s ease-in-out";
  sliderMask.style.transform = `translateX(-${currentSlide * slideWidth}px)`;
}

function goToSlide(slideIndex) {
  currentSlide = slideIndex;
  sliderMask.style.transition = "none";
  updateSlidePosition();
}

arrowLeft.addEventListener("click", () => {
  if (currentSlide === 0) {
    goToSlide(3);
  } else {
    currentSlide--;
    updateSlidePosition();
  }

  sliderDots.forEach((dot) => {
    dot.classList.remove("w-active");
    dot.setAttribute("aria-pressed", "false");
    dot.setAttribute("tabindex", "-1");
  });

  sliderDots[currentSlide].classList.add("w-active");
  sliderDots[currentSlide].setAttribute("aria-pressed", "true");
  sliderDots[currentSlide].setAttribute("tabindex", "0");
});

arrowRight.addEventListener("click", () => {
  if (currentSlide === slides.length - 1 || currentSlide * slideWidth >= 829) {
    setTimeout(() => {
      goToSlide(0);
    }, 250);
  } else {
    currentSlide++;
    updateSlidePosition();
  }

  sliderDots.forEach((dot) => {
    dot.classList.remove("w-active");
    dot.setAttribute("aria-pressed", "false");
    dot.setAttribute("tabindex", "-1");
  });

  // Reset currentSlide to 0 after the 3rd time (4th slide) is clicked
  if (currentSlide === 4) {
    currentSlide = 0;
  }

  sliderDots[currentSlide].classList.add("w-active");
  sliderDots[currentSlide].setAttribute("aria-pressed", "true");
  sliderDots[currentSlide].setAttribute("tabindex", "0");
});

window.addEventListener("resize", () => {
  slideWidth = slides[0].getBoundingClientRect().width;
});

// mobile optimization
let touchStartX = null;
let touchStartY = null;

sliderMask.addEventListener("touchstart", (e) => {
  touchStartX = e.touches[0].clientX;
  touchStartY = e.touches[0].clientY;
});

sliderMask.addEventListener("touchmove", (e) => {
  const touchCurrentX = e.touches[0].clientX;
  const touchCurrentY = e.touches[0].clientY;

  const deltaX = Math.abs(touchStartX - touchCurrentX);
  const deltaY = Math.abs(touchStartY - touchCurrentY);

  // Only prevent the default behavior when swiping horizontally
  if (deltaX > deltaY) {
    e.preventDefault(); // Prevents scrolling while swiping
  }
});

sliderMask.addEventListener("touchend", handleSwipe);

function handleSwipe(e) {
  const touchEndX = e.changedTouches[0].clientX;
  const touchDeltaX = touchStartX - touchEndX;

  // Define a threshold for the minimum swipe distance
  const swipeThreshold = 30;

  if (Math.abs(touchDeltaX) > swipeThreshold) {
    if (touchDeltaX > 0) {
      // Swipe left (next slide)
      arrowRight.click();
    } else {
      // Swipe right (previous slide)
      arrowLeft.click();
    }
  }
}

const arrowRightBlog68 = document.querySelector(".slide68_arrow");
const sliderMaskBlog68 = document.querySelector(".blog68_mask");
const slidesBlog68 = document.querySelectorAll(".blog68_slide");
let slideWidthBlog68 = slidesBlog68[0].getBoundingClientRect().width;

let currentSlideBlog68 = 0;

function updateSlidePositionBlog68() {
  sliderMaskBlog68.style.transition = "transform 0.9s ease-in-out";
  sliderMaskBlog68.style.transform = `translateX(-${
    currentSlideBlog68 * slideWidthBlog68 + 20
  }px)`;
}

function goToSlideBlog68(slideIndex) {
  currentSlideBlog68 = slideIndex;
  sliderMaskBlog68.style.transition = "none";
  updateSlidePositionBlog68();
}

arrowRightBlog68.addEventListener("click", () => {
  if (
    currentSlideBlog68 === slidesBlog68.length - 1 ||
    currentSlideBlog68 * slideWidthBlog68 >= 829
  ) {
    setTimeout(() => {
      goToSlideBlog68(0);
    }, 250);
  } else {
    currentSlideBlog68++;
    updateSlidePositionBlog68();
  }
});

// Update slideWidthBlog68 whenever the window is resized
window.addEventListener("resize", () => {
  slideWidthBlog68 = slidesBlog68[0].getBoundingClientRect().width;
});

// Touch event listeners for swiping through slides
let touchStartXBlog68 = null;
let touchStartYBlog68 = null;

sliderMaskBlog68.addEventListener("touchstart", (e) => {
  touchStartXBlog68 = e.touches[0].clientX;
  touchStartYBlog68 = e.touches[0].clientY;
});

sliderMaskBlog68.addEventListener("touchmove", (e) => {
  const touchCurrentXBlog68 = e.touches[0].clientX;
  const touchCurrentYBlog68 = e.touches[0].clientY;

  const deltaXBlog68 = Math.abs(touchStartXBlog68 - touchCurrentXBlog68);
  const deltaYBlog68 = Math.abs(touchStartYBlog68 - touchCurrentYBlog68);

  // Only prevent the default behavior when swiping horizontally
  if (deltaXBlog68 > deltaYBlog68) {
    e.preventDefault(); // Prevents scrolling while swiping
  }
});

sliderMaskBlog68.addEventListener("touchend", handleSwipeBlog68);

function handleSwipeBlog68(e) {
  const touchEndXBlog68 = e.changedTouches[0].clientX;
  const touchDeltaXBlog68 = touchStartXBlog68 - touchEndXBlog68;

  // Define a threshold for the minimum swipe distance
  const swipeThresholdBlog68 = 50;

  if (Math.abs(touchDeltaXBlog68) > swipeThresholdBlog68) {
    if (touchDeltaXBlog68 > 0) {
      // Swipe left (next slide)
      arrowRightBlog68.click();
    } else {
      // Swipe right (previous slide)
      // The arrowLeftBlog68 functionality should be added if needed
    }
  }
}
